module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ry3St"))).then(() => parcelRequire('37nVf'));